import React, { useEffect, useState } from 'react';
import useScopedCss from '../../components/useScopedCss'
import Header from '../../layout/Header';
import Columbox from './Columbox';
import WelcomeDiv from './Welcomediv';
import Footer from '../../layout/Footer';


const Dashboard = ({ handleMenuClick }) => {
  useScopedCss('./css/admin-style.css'); // Dynamically injecting CSS for this component
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  useEffect(() => {
    // Listen for the custom event from Header.jsx
    const handleToggleMenu = (event) => {
      setIsMenuOpen(event.detail); // Update the state based on event detail
    };

    window.addEventListener('toggleMenu', handleToggleMenu);

    // Cleanup event listener on unmount
    return () => {
      window.removeEventListener('toggleMenu', handleToggleMenu);
    };
  }, []);
  return (
    <>
    <Header />
    <section>
    <div className="ad-com">
    <div className={`ad-dash adda-oly ${isMenuOpen ? '' : 'leftpadd'}`}>
    <WelcomeDiv />
    <Columbox />
    </div>
    </div>
    </section>
    <Footer />
    </>
  )
}

export default Dashboard